// Run an async refresh while keeping the user's scroll position (dialog close + list reload resets it otherwise)
export async function keepScroll(fn) {
  const y = window.scrollY;
  try { return await fn(); }
  finally {
    const until = performance.now() + 700;
    const tick = () => {
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo({ top: y, behavior: "instant" });
      if (performance.now() < until) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
}
